import { FC, useState } from 'react'
import { Button, Input, Stack } from "@alexpireddu/map-ui";
import { useNavigate } from 'react-router-dom';
import { ENV_VARIABLES } from '../../infrastructure/environments';

const UserLoginForm: FC = () => {
    const [email, setEmail] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const navigate = useNavigate();

    const handleLogin = async () => {
        await fetch(`${ENV_VARIABLES.REACT_APP_BASE_PATH}/login`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                email: email,
                password: password,
            }),
        });

        navigate("/");
    };

    return (
        <Stack spacing={2}>
            <Input
                placeholder='Email'
                value={email}
                onChange={evt => setEmail(evt.target.value)}
            />
            <Input
                placeholder='Password'
                type={"password"}
                value={password}
                onChange={evt => setPassword(evt.target.value)} />
            <Button
                variant="accent"
                onClick={handleLogin}
            >Accedi</Button>
        </Stack>
    );
}

export default UserLoginForm;